module.exports = __webpack_public_path__ + "img/email.83666658.png";